import { ControlSizesXL, ControlSizesLG, ControlSizesMD, ControlSizesSM } from '../../../helpers/controlSizes/controlSizes/index.js';

const SelectSizesXL = { ...ControlSizesXL };
const SelectSizesLG = { ...ControlSizesLG };
const SelectSizesMD = { ...ControlSizesMD };
const SelectSizesSM = { ...ControlSizesSM };

export { SelectSizesLG, SelectSizesMD, SelectSizesSM, SelectSizesXL };
